import { render, staticRenderFns } from "./UrgencyCreateCase.vue?vue&type=template&id=494674a2&scoped=true&lang=pug"
import script from "./UrgencyCreateCase.vue?vue&type=script&lang=js"
export * from "./UrgencyCreateCase.vue?vue&type=script&lang=js"
import style0 from "./UrgencyCreateCase.vue?vue&type=style&index=0&id=494674a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494674a2",
  null
  
)

export default component.exports